import { MediaQueryEnum, useMediaQuery } from 'commons/utils';
import { useGetNotifications } from 'hooks/u005/useGetNotificationsHooks';
import { useTranslationWithLang } from 'hooks/useTranslationWithLang';
import { NotificationArea } from 'organisms/u003/NotificationArea';
import NotificationsIcon from '@mui/icons-material/Notifications';
import { useContext } from 'react';
import { AppContext } from 'templates/AppContextProvider';

type Props = {
  auditionId: string;
};

export const InfoSection = (props: Props) => {
  const { currentLang } = useContext(AppContext);
  const [notifications, loading, err] = useGetNotifications(props.auditionId, currentLang);
  const { t: tAuditionInfo } = useTranslationWithLang('auditionInfo');
  const { t: tMessage } = useTranslationWithLang('message');

  const isSp = useMediaQuery(MediaQueryEnum.sp);

  return (
    <NotificationArea
      title={tAuditionInfo('TU005_001')}
      icon={<NotificationsIcon className="text-white" />}
      data={notifications.map((n) => {
        return {
          id: n.id,
          title: n.title,
          notice: n.notice,
          published_at: n.publishedAt,
          file1: n.file1,
          file2: n.file2,
          file3: n.file3,
          file4: n.file4,
          file5: n.file5,
        };
      })}
      err={err ? tMessage('MU005F0044E') : null}
      loading={loading}
      expanded={false}
      noItemsMsg={tMessage('MU005F0045I')}
      buttonLabel={tAuditionInfo('TU005_014')}
      isSp={isSp}
      initialOpen={notifications.length > 0}
    />
  );
};
